import React, { memo, useState } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../Icon';
import { COLORS } from '../../../../constants/styles';
import {
  OFFICE_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
} from '../../../../constants';

import styles from './styles.styl';

function ProviderVisitTypeToggle({
  isOfficeVisit,
  manageVisitType: { setVisitType, visitType, visitTypesList },
  reasonType: { visitTypeCodes },
}) {
  const [viewNotification, setViewNotification] = useState(true);

  const isVirtualVisitAllowed = visitTypeCodes.find(
    code => code === VIRTUAL_VISIT_TYPE_CODE,
  );
  const isOfficeVisitAllowed = visitTypeCodes.find(
    code => code === OFFICE_VISIT_TYPE_CODE,
  );

  const isAllowedToggleVisitType =
    isVirtualVisitAllowed && isOfficeVisitAllowed;

  return (
    <div className={styles.root}>
      {isAllowedToggleVisitType && (
        <div className={styles.toggle}>
          {visitTypesList.map(({ name, code, id }) => (
            <div
              className={cn(styles.button, {
                [styles.activeButton]: visitType.id === id,
              })}
              key={id}
              onClick={() => setVisitType({ name, code, id })}
            >
              {name}
            </div>
          ))}
        </div>
      )}
      {viewNotification && !isOfficeVisit && (
        <div className={styles.notification}>
          <Icon
            size={8}
            name="ico-24-close"
            className={styles.closeBtn}
            style={{ fill: COLORS.fontPrimary }}
            onClick={() => setViewNotification(false)}
          />
          {isVirtualVisitAllowed && !isOfficeVisitAllowed && (
            <FormattedMessage id="appointmentForm.rescheduleFlow.notification" />
          )}
          {!isOfficeVisit && (
            <FormattedMessage
              id="appointmentForm.rescheduleFlow.notification.warning"
              values={{
                visit: (
                  <b>
                    <FormattedMessage id="appointmentForm.rescheduleFlow.notification.onlineVisit" />
                  </b>
                ),
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}

ProviderVisitTypeToggle.propTypes = {
  isOfficeVisit: PropTypes.bool,
  reasonType: PropTypes.object,
  manageVisitType: PropTypes.object,
};

export default memo(ProviderVisitTypeToggle);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviderDetails/ProviderVisitTypeToggle/index.jsx